export default {
  filterData : {
    Products: {
      label: 'Продукты',
      allFilterLabel: "Все продукты",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Темы",
      allFilterLabel: "все темы",
      items: [
        { name: "Управление доступом", id: "Access management" },
        { name: "Аналитика и мониторинг", id: "Analytics and monitoring" },
        { name: "Доставка приложений и обеспечение их безопасности", id: "Application delivery and security" },
        { name: "Citrix и Google", id: "Citrix and Google" },
        { name: "Citrix и Microsoft", id: "Citrix and Microsoft" },
        { name: "Переход в облако", id: "Cloud migration" },
        { name: "Сравнить", id: "Compare" },
        { name: "Совместная работа с контентом", id: "Content collaboration" },
        { name: "Цифровые рабочие места", id: "Digital workspaces" },
        { name: "Удобство работы сотрудников", id: "Employee experience" },
        { name: "Гибридное облако", id: "Hybrid cloud" },
        { name: "Работа в гибридном режиме", id: "Hybrid work" },
        { name: "Управление и оптимизация", id: "Manage and optimize" },
        { name: "Микросервисы и DevOps", id: "Microservices and devOps" },
        { name: "Внедрение и адаптация", id: "Onboarding and adoption" },
        { name: "Партнерские интеграции", id: "Partner integrations" },
        { name: "Описание продукта", id: "Product overview" },
        { name: "безопасность и соответствие стандартам", id: "Security and compliance" },
        { name: "Малый бизнес", id: "Small business" },
        { name: "Спецификации", id: "Specifications" },
        { name: "Устойчивое развитие", id: "Sustainability" },
        { name: "Унифицированное управление конечными устройствами", id: "Unified endpoint management" },
        { name: "VDI и DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: 'Тип',
      allFilterLabel: "Все типы",
      items: [
        { name: "Аналитический отчет", id: "Analyst report" },
        { name: "Инструмент оценки", id: "Assessment tool" },
        { name: "История клиента", id: "Customer story" },
        { name: "Справочник", id: "Data sheet" },
        { name: "Презентация", id: "Demo" },
        { name: "Электронная книга", id: "eBook" },
        { name: "Руководство", id: "Guide" },
        { name: "Инфографика", id: "Infographic" },
        { name: "Интерактивный обзор", id: "Interactive tour" },
        { name: "Подкаст", id: "Podcast" },
        { name: "Комплект ресурсов", id: "Resource kit" },
        { name: "Обзор решения", id: "Solution brief" },
        { name: "Технический обзор", id: "Technical brief" },
        { name: "Видео", id: "Video" },
        { name: "Вебинар", id: "Webinar" },
        { name: "Информационный документ", id: "White paper" },
      ],
    },
    Industry: {
      label: "Отрасль",
      allFilterLabel: "Все отрасли",
      items: [
        { name: "Образование", id: "education" },
        { name: "Финансовые услуги", id: "financial_service" },
        { name: "Государственные учреждения", id: "government" },
        { name: "Здравоохранение", id: "healthcare" },
        { name: "Производство", id: "manufacturing" },
        { name: "Розничные продажи", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Поиск в библиотеке",
    titles : {
      label1: "Набирает популярность",
      label2: "Самые новые ресурсы",
      label3: "Недавно просмотренное",
      label4: "Рекомендуемые ресурсы"
    },
    showMoreLabel: "Показать больше",
    clearAllSelected: "Очистить все выбранное",
    searchResults: "Результаты поиска для",
    clearAllFilters: "Очистить все фильтры",
    noResultsFound: "Нет активов, соответствующих выбранным вами критериям",
    resetView: "Изменить вид",
    filterLabel: "Фильтры",
    filteredRes: "Отфильтрованные результаты",
    filterRes: "Фильтровать результаты",
    clearAllCta: "Очистить все",
    applyCta: "Применить",
    view: "Просмотр",
    includeEnglishRes: "Включить ресурсы на английском языке"
  };